import { Box } from "@mui/material";

import { colors } from "@/Utils";

export const Caret = (props) => {
  return (
    <Box {...props}>
      <Box
        sx={{
          width: 0,
          height: 0,
          borderStyle: "solid",
          borderWidth: "0 3.5px 7px 3.5px",
          borderColor: `transparent transparent ${colors.lightGray} transparent`,
          opacity: props.enable === "top" ? 0.3 : 1,
          "&:hover": {
            borderColor: `transparent transparent ${colors.yellow} transparent`,
          },
        }}
        {...props}
      />
      <Box
        sx={{
          width: 0,
          height: 0,
          borderStyle: "solid",
          borderWidth: "7px 3.5px 0 3.5px",
          borderColor: `${colors.lightGray} transparent transparent transparent`,
          opacity: props.enable === "bottom" ? 0.3 : 1,
          marginTop: "3px",
          "&:hover": {
            borderColor: `${colors.yellow} transparent transparent transparent`,
          },
        }}
        {...props}
      />
    </Box>
  );
};
